import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Popover, TextField, Typography, Divider, Switch, FormControlLabel } from '@material-ui/core';
import moment from 'moment';
import routePaths from '../../routePaths';

class ActComments extends React.Component {
  state = {
    open: false,
    top: 0,
    left: 0,
    text: '',
    showMyCommentsOnly: false,
    comments: this.props.comments,
    blockId: null,
    commentedParagraph: null,
  };

  componentDidMount() {
    if (this.props.preview) return;
    const sections = document.querySelectorAll('[id^="block"]');
    sections.forEach(section => {
      const element = ReactDOM.findDOMNode(section);
      element.tabIndex = 0;
      element.addEventListener('focus', this.handleSectionFocus);
      element.addEventListener('click', this.handleClick);
      element.addEventListener('mouseenter', this.handleMouseOver);
      element.addEventListener('mouseleave', this.handleMouseOut);

      if (this.props.comments && this.props.comments.some(c => c.blockId === element.id)) {
        const sectionComments = this.props.comments.filter(c => c.blockId === element.id);
        const commentsDiv = document.createElement("div");
        commentsDiv.className = "comments-panel";
        const countDiv = document.createElement("div");
        countDiv.innerHTML = `<div class="comments-icon"><strong>${sectionComments.length}</strong>&nbsp;<i class="fa fa-comments "></i></div>`;
        commentsDiv.appendChild(countDiv);
        section.insertAdjacentElement('afterbegin', commentsDiv);
      }
    });
  }

  handleSectionFocus = event => {
    const element = document.getElementById(event.target.id);
    this.setState({ blockId: event.target.id, commentedParagraph: element.innerHTML });
    element.classList.add('active-block');
    const elems = document.querySelectorAll('[id^="block"]');
    [].forEach.call(elems, el => {
      if (el.id !== event.target.id)
        el.classList.remove('active-block');
    });
  };

  handleSectionBlur = event => {
    this.setState({ blockId: null, commentedParagraph: null });
    const element = document.getElementById(event.target.id);
    if (element && this.state.blockId !== event.target.id) element.classList.remove('active-block');
  };

  handleKeyDown = event => {
    if (event.keyCode === 13 && this.state.blockId) {
      event.preventDefault();
      const element = document.getElementById(this.state.blockId);
      const elementRect = element.getBoundingClientRect();
      this.setState({
        open: true,
        top: elementRect.y,
        left: elementRect.x,
      });
    }
  }

  handleClick = event => {
    this.setState({
      open: true,
      top: event.clientY,
      left: event.clientX,
    });

    const element = document.getElementById(event.target.id);
    if (element) element.classList.add('active-block');
    return;
  };

  handleMouseOver = event => {
    event.stopPropagation();
    const element = document.getElementById(event.target.id);
    if (element && element.innerHTML) {
      element.classList.add('active-block');
      this.setState({ blockId: event.target.id, commentedParagraph: element.innerHTML });
    }

    const elems = document.querySelectorAll('[id^="block"]');

    [].forEach.call(elems, el => {
      if (el.id !== event.target.id)
        el.classList.remove('active-block');
    });
  }

  handleMouseOut = event => {
    const element = document.getElementById(event.target.id);
    if (element && this.state.blockId !== event.target.id) element.classList.remove('active-block');
  }

  handleClose = () => {
    const element = document.getElementById(this.state.blockId);
    if (element) element.classList.remove('active-block');

    this.setState({ open: false, blockId: null, commentedParagraph: null });
  }

  handleTextChange = event => this.setState({ text: event.target.value });

  handleSave = () => {
    this.props.onSave(this.state.text, this.state.blockId, this.state.commentedParagraph);
    this.setState({ open: false, text: '', blockId: null });
  }

  handleShowMyComments = e => {
    const showMyCommentsOnly = e.target.checked;
    this.setState({
      showMyCommentsOnly,
      comments: showMyCommentsOnly ? this.props.comments.filter(c => c.userId === this.props.userId) : this.props.comments,
    });
  }

  render() {
    const { content, onSave, authenticationRequired, userSignedIn } = this.props;
    const { top, open, text, blockId, comments } = this.state;

    return (
      <React.Fragment>
        <div onKeyDown={this.handleKeyDown} dangerouslySetInnerHTML={{ __html: content }} />
        {(authenticationRequired && userSignedIn)
          ? <div>
            <Divider style={{ marginTop: 16 }} />
            <FormControlLabel control={<Switch color="primary" onChange={this.handleShowMyComments} />} label="Pokaż tylko moje komentarze" />
          </div>
          : null}
        <Popover
          anchorReference="anchorPosition"
          anchorPosition={{ top, left: (window.innerWidth > 1500 ? 1240 + 32 + ((window.innerWidth - 1240) / 2) : window.innerWidth - 32) }}
          open={open}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <div style={{ padding: 10, width: 250 }}>
            {comments
              ? <div>
                <Typography variant="subtitle1" gutterBottom>Komentarze</Typography>
                {comments
                  .filter(c => c.blockId === blockId)
                  .map(c => (
                    <div key={c.id}>
                      <Typography variant="caption" component="p">{moment(c.createdAt).format('YYYY-MM-DD HH:mm')}</Typography>
                      {c.text}
                      <Divider style={{ marginTop: 4, marginBottom: 4 }} />
                    </div>
                  ))}
              </div>
              : null}
            <Typography variant="subtitle1">Dodaj</Typography>
            {authenticationRequired && !userSignedIn
              ? <div>Aby dodać komentarz musisz <Link to={routePaths.signIn}>zalogować</Link> się do systemu</div>
              : <React.Fragment>
                <div>
                  <TextField
                    placeholder="Wprowadź treść komentarza"
                    margin="dense"
                    fullWidth
                    rows={5}
                    multiline
                    autoFocus
                    onChange={this.handleTextChange}
                  />
                </div>
                <div style={{ textAlign: 'right', marginTop: 10 }}>
                  <button className="btn" disabled={!text || !onSave} onClick={this.handleSave}>Zapisz</button>
                </div>
              </React.Fragment>}
          </div>
        </Popover>
      </React.Fragment>
    );
  }
}

ActComments.propTypes = {
  content: PropTypes.string.isRequired,
  onSave: PropTypes.func,
  comments: PropTypes.array,
  authenticationRequired: PropTypes.bool,
  userSignedIn: PropTypes.bool,
  userId: PropTypes.string,
  preview: PropTypes.bool,
};

export default ActComments;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/ActComments.js